import common from '../common';

export default class UndoManager {
	constructor() {
		// Constants.
		this.MAX_STACK_SIZE = 3;

		// Attributes.
		this._arrLayerState = [];

		// Signals.
		this.signals = {};
		this.signals.onStackEmpty = new P3.utils.MiniSignal();
		this.signals.onStackIncreased = new P3.utils.MiniSignal();
	}

	save() {
		const drawlayerData = common.game.canvas.drawLayer.context.getImageData(0, 0, common.game.canvas.WIDTH, common.game.canvas.HEIGHT);
		const drawDynOutlineData = common.game.canvas.drawLayer.dynOutlineContext.getImageData(0, 0, common.game.canvas.WIDTH, common.game.canvas.HEIGHT);
		const fillLayerData = common.game.canvas.fillLayer.colourContext.getImageData(0, 0, common.game.canvas.WIDTH, common.game.canvas.HEIGHT);
		const fillColourCodeData = common.game.canvas.fillLayer.colourCodeContext.getImageData(0, 0, common.game.canvas.WIDTH, common.game.canvas.HEIGHT);
		const stampsData = common.gameScene.allStamps.length;

		if (this._arrLayerState.length === this.MAX_STACK_SIZE)
			this._arrLayerState.splice(0, 1);

		this._arrLayerState.push({
			drawlayerData: drawlayerData,
			drawDynOutlineData: drawDynOutlineData,
			fillLayerData: fillLayerData,
			fillColourCodeData: fillColourCodeData,
			stampsData: stampsData
		});

		// Signals.
		this.signals.onStackIncreased.dispatch();
	}

	undo() {
		if (this._arrLayerState.length === 0) return;

		const layerState = this._arrLayerState.splice(this._arrLayerState.length - 1, 1)[0];

		common.game.canvas.fillLayer.setLayerData(layerState.fillLayerData, layerState.fillColourCodeData);
		common.game.canvas.drawLayer.setLayerData(layerState.drawlayerData, layerState.drawDynOutlineData);

		if (common.gameScene.allStamps.length > layerState.stampsData) {
			common.gameScene.gameLayer.removeChild(common.gameScene.allStamps[common.gameScene.allStamps.length - 1]);
			common.gameScene.allStamps.splice(common.gameScene.allStamps.length - 1, 1);
		}

		// Signals.
		if (this._arrLayerState.length === 0)
			this.signals.onStackEmpty.dispatch();
	}

	clear() {
		this._arrLayerState = [];
		this.signals.onStackEmpty.dispatch();
	}
}
